import { Box, TextField, Button, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './signinPageStyles.scss';

const baseUrl = window.location.origin;

const SigninPage = () => {
    useEffect(() => {
        document.title = 'Aggie - Sign In';
    }, []);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); // New state variable for error message

    const navigate = useNavigate(); // Use useHistory for navigation

    const validateEmail = (email: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const validatePassword = (password: string) => {
        const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/;
        return re.test(password);
    }

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setEmailError('');
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
        setPasswordError('');
    };

    const handleSubmit = async () => {
        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        if (!validatePassword(password)) {
            setPasswordError('Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, and one number');
            return;
        }

        try {
            const response = await fetch(`${baseUrl}/signin/email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (data.status === 'success') {
                navigate('/fulfill', { replace: true }); // Redirect to the fulfill page
            } else {
                setErrorMessage(data.error); // Set the error message
            }
        } catch (error) {
            console.error('Error:', error);
            setErrorMessage('An error occurred while trying to sign up.'); // Set the error message
        }
    };

    return (
        <div id="signinPageContainer">
            <div className='pageTitle'>Sign In</div>
            <h2 className="text-center mb-10 text-gray-500">Sign in with your preferred provider</h2>
            <Box
                component="form"
                noValidate
                autoComplete="off"
                className="formContainer"
                action={`${baseUrl}/signin/email`}
                method="POST"
            >
                <TextField
                    label="Email"
                    placeholder="Enter Your Email"
                    variant="outlined"
                    onChange={handleEmailChange}
                    className="textField"
                    error={!!emailError}
                    helperText={emailError}
                    name="email"
                    value={email}
                />
                <TextField
                    label="Password"
                    placeholder="Enter your Password"
                    variant="outlined"
                    onChange={handlePasswordChange}
                    className="textField"
                    error={!!passwordError}
                    helperText={passwordError}
                    type="password"
                    name="password"
                    value={password}
                />
                <br />
                <a href="/aggie-react-app/signup" target="_blank" className='footerLink'>Don't have an account?  Sign up with email</a>
                <br />
                <Button type="submit" variant="contained">Submit</Button>
            </Box>
            <br />
            <br />
            <button className="gsi-material-button" 
                onClick={(event) => {
                event.preventDefault();
                window.location.href = '/login/google';
            }}>
                <div className="gsi-material-button-state"></div>
                <div className="gsi-material-button-content-wrapper">
                    <div className="gsi-material-button-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xlinkHref="http://www.w3.org/1999/xlink" style={{display: 'block'}}>
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                        <path fill="none" d="M0 0h48v48H0z"></path>
                    </svg>
                    </div>
                    <span className="gsi-material-button-contents">Sign in with Google</span>
                    <span style={{display: 'none'}}>Sign in with Google</span>
                </div>
            </button>
        </div>
    );
}

export default SigninPage;